module.exports = __webpack_public_path__ + "img/honor5.cd1727c7.jpg";